import { Logger } from '@core/logger'

import { sendEvent } from './sendEvent'

type TExperimentReportEvent = 'Experiment User Participate' | 'Experiment User Split'

/**
 * Bridges `core/experiments`' reportEvent hook to audio-web's single `experiment_exposure`
 * event. audio-web had one exposure event, so we treat participation as the exposure signal
 * ('Experiment User Split' is a muse-only concept audio-web didn't track). Pass to
 * `experiments.init({ reportEvent })`.
 */
export const reportExperimentExposure = (
    event: TExperimentReportEvent,
    { experiment_id: experimentId, variation }: { experiment_id: number; variation: number },
) => {
    if (event !== 'Experiment User Participate') {
        return
    }

    // Immediate rather than batched: a lost exposure silently shrinks the denominator of the A/B,
    // and only the awaited delivery result can tell us it happened.
    sendEvent(
        {
            name: 'experiment_exposure',
            payload: {
                // audio-web sent experiment_id as the raw number (its `string` type was
                // inaccurate); match the wire form so downstream ingestion is unchanged.
                experiment_id: experimentId,
                experiment_variation: String(variation),
            },
        },
        true,
    ).then(({ delivered, error, failure }) => {
        if (delivered) {
            return
        }

        Logger.error('Experiment exposure delivery failed', {
            experimentId,
            variation,
            ...error,
            error: failure,
        })
    })
}
